import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer';
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Add, Delete, Edit, Label } from '@mui/icons-material'
import { dataTypeOptions } from '../../util';
import CustomDataGrid from '../../components/CustomDataGrid';

const ResourceGroup = () => {
    const [ showModal, setShowModal ] = useState(false)
    const [ selectedResourceGroup, setSelectedResourceGroup ] = useState(null);
    const [ domianList, setDomainList ] = useState([]);
    const [ records, setRecords ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false);
    const [ deleteModal, setDeleteModal ] = useState(false);
    const [ isDeleting, setIsDeleting ] = useState(false);
    const defaultResourceGroup = {
        "name": "", "value":""
    }

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        {
            field: 'actions', headerName: 'Actions', flex: 0.2, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit Domain' className='p-0 m-0'
                        onClick={() => {
                            setSelectedResourceGroup(params?.row || defaultResourceGroup);
                            setShowModal(true)
                        }}
                    >
                        <Edit />
                    </IconButton>
                    {/* <IconButton
                        size='small'
                        color="error"
                        variant="outlined" title='Delete Recourse Group' className='p-0 m-0'
                        onClick={() => {
                            console.log(params?.row);
                            setSelectedResourceGroup(params?.row ?? defaultResourceGroup);
                            setDeleteModal(true)
                        }}
                    >
                        <MotionPhotosOffIcon />
                    </IconButton> */}
                </div>
            )
        },
        { field: 'name', headerName: 'Resource Group Name', flex: 1 },
        { field: 'value', headerName: 'Value', flex: 0.8 },
    ];

    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("domains");
            const groupRes = await getList("resource_grps")
            if(groupRes?.responseCode === "00") {
                setRecords(groupRes?.listing || [])
            } else {
                enqueueSnackbar(groupRes?.message || groupRes?.responseMessage || 'An error occurred', { variant: 'error' })
            }
            
            if(resp?.responseCode === "00") {
                setDomainList(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const createOrUpdateResourceGroup = async (values, { resetForm }) => {

        let resourceGroupObject = {...values};
        resourceGroupObject.resources = null;
        try {
            const resp = await AddorUpdateRecord("resourcegrp", resourceGroupObject?.id ? "update" : 'add', resourceGroupObject);
            if(resp?.responseCode === "00") {
                init();
                setSelectedResourceGroup(null)
                setShowModal(false)
                enqueueSnackbar('Action performed successfully')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const deleteResourceGroup = async () => {
        try {
            setIsDeleting(true);

            let resourceGroupObject = {...selectedResourceGroup};
            resourceGroupObject.resources = null;

            const res = await AddorUpdateRecord("resourcegrp", "delete", resourceGroupObject);

            if(res.responseCode === "00") {
                init();
                setSelectedResourceGroup(null);
                setDeleteModal(false);
                enqueueSnackbar('Resource Group deleted successfully', { variant: 'success' });
            }
            else {
                enqueueSnackbar(res?.message ?? res?.responseMessage ?? 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message ?? err?.responseMessage ?? 'An error occurred', { variant: 'error' })
        }
        finally {
            setIsDeleting(false);
        }
    }

    useEffect(() => {
        init()
    }, [])

    return (
        <PageContainer pageTitle='Resource Group' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">All</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Resource Group</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Button variant="contained" onClick={() => { setSelectedResourceGroup(defaultResourceGroup); setShowModal(true) }}>Create Resource Group</Button>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ height: 550, width: '100%', textAlign: 'center' }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={records}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {
                {

                    "resourceName": "Test Resource",
        
                    "resourceGroupID": 11,
        
                    "description": "A test Resource",
        
                    "url": "",
        
                    "tags": "test tags for resource",
        
                    "targetView": "test_view"
        
                }
            } */}

            <Dialog open={showModal} maxWidth="lg">
                <Formik 
                enableReinitialize 
                initialValues={selectedResourceGroup} 
                onSubmit={createOrUpdateResourceGroup}
                >
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent className='pl-4 pr-4'>
                                <h3 className='text-bold mt-05' >{values?.id ? 'Update' : 'Create'} Resource Group</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput id="name" required label="Resource Group Name" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="value" label="Resource Group Value" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/* <SelectInput field="id" label='OFI Category' fieldDisplay='id' id='ofi_category' options={ofis} />    */}
                                        <SelectInput required field="domainID" label='Domain List' fieldDisplay='domainName' id='domainID' options={domianList} />
                                    </Grid>
                                </Grid>
                                
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedResourceGroup(null) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained" disabled={isSubmitting} >
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        values?.id ? 'Update Resource' : 'Add Resource'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={deleteModal} maxWidth="lg">
                <DialogContent className='pl-4 pr-4'>
                    <p className='text-bold mt-05' style={{ fontSize: "1.2em" }} >Are you sure you want to <b style={{ color: "red" }}>delete the Resource Group</b> from the system</p>
                    <Divider className="mt-2" />
                </DialogContent>
                <DialogActions className='pr-3 pb-3'>
                    <Button 
                        disabled={isDeleting} 
                        onClick={() => { 
                            if(!isDeleting) { 
                                setDeleteModal(false); 
                                setSelectedResourceGroup(null) 
                            }}} 
                        color="secondary" 
                        variant="contained" >
                            Cancel
                        </Button>
                    <Button variant="contained" disabled={isDeleting} onClick={deleteResourceGroup} >
                        {
                            isDeleting ?
                            <CircularProgress size={15} color="inherit" />
                            :
                            'Delete Resource Group'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    )
}

export default ResourceGroup